import { FunctionComponent } from 'react';
import './field-group.styl';

const FieldGroup: FunctionComponent<
	React.PropsWithChildren<DynamicForm.FieldGroupElementProps>
> = ({ props, children }) => {
	const { className = '' } = props;
	return (
		<div {...props} className={`fieldGroup ${className}`}>
			{children}
		</div>
	);
};

export default FieldGroup;
